import { axiosClient } from "./client";
import {
  GET_ALL_SCHEDULES,
  CREATE_SCHEDULES,
  GET_SCHEDULE_TEMPLATE,
  ADD_SCHEDULE_TIME_SLOT,
  REMOVE_SCHEDULE_TIME_SLOT,
  GET_ALL_SCHEDULE_BY_EXPERT_ID,
} from "./client/endpoints";

const fetchExpertSchedules = async (data: number): Promise<any> => {
  const response = await axiosClient.get<any>(
    `${GET_ALL_SCHEDULE_BY_EXPERT_ID}?expert_id=${data}`
  );
  return response.data;
};

const createSchedules = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(CREATE_SCHEDULES, data);
  return response.data;
};

const getScheduleTemplate = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(GET_SCHEDULE_TEMPLATE, data);
  return response.data;
};

const addScheduleTimeSlot = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(ADD_SCHEDULE_TIME_SLOT, data);
  return response.data;
};

const removeScheduleTimeSlot = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(REMOVE_SCHEDULE_TIME_SLOT, data);
  return response.data;
};

const expertScheduleService = {
  fetchExpertSchedules,
  createSchedules,
  getScheduleTemplate,
  addScheduleTimeSlot,
  removeScheduleTimeSlot,
};

export default expertScheduleService;
